export const UXFEEDBACK_COOKIE_KEY = 'shouldTriggerFavoritesUxfeedbackCampaign';
